import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter, map } from 'rxjs';
import { OtherService } from 'src/app/services/other.service';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css'],
})
export class LandingPageComponent implements OnInit {
  isLogin = false;
  specialistUser = null;

  constructor(
    private router: Router,
    private otherService: OtherService,
    private swUpdate: SwUpdate,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.checkIfVersionUpdated();
    this.otherService.isUserLogin$.subscribe(condition => this.isLogin = condition);
    this.otherService.isSpecialistUserLogin$.subscribe(specialistUser => this.specialistUser = specialistUser);
  }

  logOut() {
    this.otherService.logout();
    this.router.navigate(['/home']);
  }

  checkIfVersionUpdated() {
    this.swUpdate.versionUpdates
      .pipe(
        filter((evt: VersionReadyEvent) => evt.type === 'VERSION_READY'),
        map(evt => ({
          type: 'UPDATE_AVAILABLE',
          current: evt.currentVersion,
          available: evt.latestVersion,
        }))
      ).subscribe(() => {
        let snack = this.snackBar.open(
          'نسخه جدیدی منتشر شده است !!',
          'به روز رسانی',
          {
            panelClass: ['snackBar-class'],
          }
        );

        snack.onAction().subscribe(() => {
          this.swUpdate.activateUpdate().then(() => {
            document.location.reload();
          });
        });
      });
  }
}
